"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M12.126 11.896H2c-.048 4.323 2.731 8.34 7.075 9.668.43.132.86.23 1.292.302l1.758-9.97z" }),
    React.createElement("path", { d: "M16.511 11.896l.65-3.68h4.092a9.98 9.98 0 00-6.33-5.777C9.936.915 4.676 3.48 2.745 8.216H16.51l-2.39 13.557a9.993 9.993 0 007.44-6.848 9.98 9.98 0 00.438-3.03l-5.488.001z" })), "Twinmotion");
//# sourceMappingURL=Twinmotion.js.map